import { useTranslation } from '@conekta/cronos/i18n';
import { awsS3Url } from 'app/util/constants';

import './styles.scss';

export const BinPhysicalInformation = ({ show }: { show: boolean }) => {
  const tRoot: string = 'iFrame.checkout';
  const { t } = useTranslation();

  if (!show) return <></>;

  return (
    <div className="bin-physical-info">
      <img src={`${awsS3Url}/img/icons/info-raspberry-24px.svg`} alt="alert" />
      <div>{t(`${tRoot}.cardForm.messageBIN`)}</div>
    </div>
  );
};
